import {
  CardBody
} from 'reactstrap'

const CardLoading = () => {
  return (
    <div className="shadow CardPromo shine--load">
      <div className="thumbnail shine">
        <div className="merchant-logo shine">
        </div>
      </div>
      <CardBody className="d-flex flex-column justify-content-end">
        <div className="end-date"></div>
      </CardBody>
    </div>
  )
}

export default CardLoading